var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('loading',{attrs:{"active":_vm.isLoading},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }